module.exports = __webpack_public_path__ + "a24faf01f7691c7231fffff4447dc1a9.pdf";